import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRebootFailed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.4976 25.5021C68.062 43.8068 62.8206 57.6083 47.1726 65.8731C37.2226 71.1285 25.767 74.9868 19.8893 84.5823C-1.51919 119.532 44.1152 148.28 73.4972 114C98.4156 84.9275 136.624 152.34 172.997 97.5C205.496 48.5007 138.997 -23.0008 87.4976 25.5021Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 88,
			cy: 120,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 39,
			cy: 35,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76 25H115C121.075 25 126 29.9249 126 36V36C126 42.0751 121.075 47 115 47H60.75C54.8129 47 50 51.8129 50 57.75V57.75C50 63.6871 54.8129 68.5 60.75 68.5H139.5C145.575 68.5 150.5 73.4249 150.5 79.5V79.5C150.5 85.5751 145.575 90.5 139.5 90.5H87.75C81.2607 90.5 76 95.7607 76 102.25V102.25C76 108.739 81.2607 114 87.75 114H107",
			stroke: "url(#paint0_linear_6332_14278)",
			strokeWidth: 5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 76,
			cy: 25,
			r: 6,
			fill: "url(#paint1_linear_6332_14278)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 106,
			cy: 114,
			r: 6,
			fill: "url(#paint2_linear_6332_14278)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.4261 42.5436C80.668 38.3095 84.1721 35 88.4131 35H107.587C111.828 35 115.332 38.3095 115.574 42.5436L117.517 76.5436C117.779 81.1338 114.127 85 109.53 85H86.4702C81.8725 85 78.2209 81.1338 78.4832 76.5436L80.4261 42.5436Z",
			fill: "url(#paint3_linear_6332_14278)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 98,
			cy: 54,
			rx: 7,
			ry: 7,
			transform: "rotate(-90 98 54)",
			stroke: "url(#paint4_linear_6332_14278)",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93 71H103",
			stroke: "url(#paint5_linear_6332_14278)",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.333 68.0001C135.333 75.3639 129.364 81.3334 122 81.3334C114.636 81.3334 108.667 75.3639 108.667 68.0001C108.667 60.6363 114.636 54.6667 122 54.6667C129.364 54.6667 135.333 60.6363 135.333 68.0001Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M122 60.3333C122.552 60.3333 123 60.781 123 61.3333V69.3333C123 69.8855 122.552 70.3333 122 70.3333C121.448 70.3333 121 69.8855 121 69.3333V61.3333C121 60.781 121.448 60.3333 122 60.3333ZM122 72.3333C122.552 72.3333 123 72.781 123 73.3333V74.6666C123 75.2189 122.552 75.6666 122 75.6666C121.448 75.6666 121 75.2189 121 74.6666V73.3333C121 72.781 121.448 72.3333 122 72.3333Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_6332_14278",
				x1: 53.8326,
				y1: 29.5254,
				x2: 132.356,
				y2: 119.04,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_6332_14278",
				x1: 70.4576,
				y1: 19.6102,
				x2: 81.1356,
				y2: 30.3898,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_6332_14278",
				x1: 100.458,
				y1: 108.61,
				x2: 111.136,
				y2: 119.39,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_6332_14278",
				x1: 79.5254,
				y1: 37.5424,
				x2: 123.022,
				y2: 72.6713,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_6332_14278",
				x1: 91.5339,
				y1: 47.7119,
				x2: 103.992,
				y2: 60.2881,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_6332_14278",
				x1: 93.3814,
				y1: 71.0508,
				x2: 93.5559,
				y2: 72.8133,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgRebootFailed);
export { ForwardRef as ReactComponent };
